import React, { useEffect, useState } from 'react';
import { Wrapper } from './styles';
import { Menu } from '../../../components/Menu';
import { usePages } from '../../../hooks/Pages';
import FooterLayout from '../../Footer';
import { useAuth } from '../../../hooks/Auth';
import PopupComponent from '../../../components/PopupContainer';

import Particles from 'react-particles-js';
import ImageSliderBackground from '../../../components/ImageBackgroundSlider';
import { useLocation, useParams } from 'react-router-dom';
import { useConfiguration } from '../../../hooks/Configuration';
import api from '../../../services/api';
import Loader from '../../DashboardPages/core/components/Loader';
import { urlWebsite } from '../../../config';
import MainLayout from '../header';

interface IParams {
  projectHash: string;
  eventHash: string;
}


const DefaultLayout: React.FC = ({ children }) => {
  const page = window.location.pathname !== '/';
  const { menu, setMenu, prepareMenu } = usePages();
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const { token,setTrackingMarketing, user, handleApiErrors, signOut } = useAuth();
  const { configuration, setConfiguration, setProjectHash, setEventHash } = useConfiguration();

  const [loading, setLoading] = useState(false);

  useEffect(() => {

    /* if (user && user.email !== 'guilherme@encontrodigital.com.br') {
        signOut();
        window.location.href = '/';
      } */



        

  }, [user])

  useEffect(() => {
  const marketing_params: Record<string, any> = {
      "src": params.get("src") || '',
      "utm_source": params.get("utm_source") || '',
      "utm_medium": params.get("utm_medium") || '',
      "utm_content": params.get("utm_content") || '',
      "utm_campaign": params.get("utm_campaign") || '',
      "utm_term": params.get("utm_term") || ''
    }

    if (marketing_params?.src || marketing_params?.utm_source || marketing_params?.utm_campaign) {
      setTrackingMarketing(marketing_params);
    }



  },[])

  return (
    <MainLayout>
      {loading && <Loader message='Carregando' />}
      <Menu menuList={menu} fixedMenu={false} />
      <Wrapper background_color={configuration.background_color} background={`${urlWebsite}/${configuration.background}`}>



        {children}

        <PopupComponent />



      </Wrapper>
    </MainLayout>
  );
};

export default DefaultLayout;
